import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
export function BonusSection() {
  return <section aria-labelledby="bonos" className="bg-ink-900" data-id="element-16" data-mp="1of2ea2x0qe9o">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" style={{
      paddingBottom: "4px",
      paddingTop: "9px"
    }} data-id="element-17" data-mp="22g52ombhk0nr">
        <div className="max-w-3xl" data-id="element-18" data-mp="1ydryi2ce0at3">
          <p className="inline-flex items-center gap-2 rounded-full border border-ball-400/30 bg-ball-400/10 px-3 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-ball-400" data-id="element-19" data-mp="1yet802dr8p8p">
            <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-20" data-mp="15qnr5qptnke5" />
            100% gratis
          </p>
          <h2 id="bonos" className="mt-5 font-display text-3xl uppercase leading-tight text-white sm:text-4xl" data-id="element-21" data-mp="1jibzdiwy9opu">
            5 bonos exclusivos
          </h2>
          <p className="mt-4 text-base leading-relaxed text-slate-300" data-id="element-22" data-mp="qzy9c5huv71b">
            Solo por comprar hoy. Valorados en <span className="text-white" data-id="element-23" data-mp="mzo4wx9poook">$54 USD</span>. Tuyos sin
            costo adicional.
          </p>
        </div>

        <ul className="mt-10 space-y-4" data-id="element-24" data-mp="29rbiz2457i19">
          {bonuses.map(bonus => <li key={bonus.number} className="grid gap-4 rounded-2xl border border-ink-600 bg-ink-800 p-6 sm:grid-cols-[auto_1fr] sm:gap-6" data-id="element-25" data-mp="2eqwe11g6z68p">
              <span className="font-display text-3xl leading-none text-court-400 sm:text-4xl" data-id="element-26" data-mp="2jieiw0lc5qyy">
                {bonus.number}
              </span>
              <div data-id="element-27" data-mp="1qtgztv9avq55">
                <div className="flex flex-wrap items-center gap-3" data-id="element-28" data-mp="1qu0jphiigolt">
                  <h3 className="font-semibold text-white sm:text-lg" data-id="element-29" data-mp="1vsbtjs8t2z41">{bonus.title}</h3>
                  <span className="inline-flex shrink-0 items-center gap-2 rounded-full bg-ink-700 px-3 py-1 text-xs font-bold uppercase tracking-wider text-slate-400" data-id="element-30" data-mp="1vu51rbz2hre5">
                    <span className="line-through" data-id="element-31" data-mp="25s2p7x93rk5p">{bonus.value}</span>
                    <span className="text-ball-400" data-id="element-32" data-mp="3c7d08vhmwp37">Gratis</span>
                  </span>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-slate-400" data-id="element-33" data-mp="3h4ln39dq9has">{bonus.description}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}